import { useState } from 'react';

const initialFormData = {
  name: '',
  location: '',
  flag: '🌍',
  host: '',
  port: 5000,
  ssh_user: 'root',
  ssh_port: 22
};

export const useNodeForm = () => {
  const [formData, setFormData] = useState(initialFormData);

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const setFormDataFromNode = (node) => {
    setFormData({
      name: node.name || '',
      location: node.location || '',
      flag: node.flag || '🌍',
      host: node.host || '',
      port: node.port || 5000,
      ssh_user: node.ssh_user || 'root',
      ssh_port: node.ssh_port || 22
    });
  };

  const updateFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const getFormData = () => formData;

  return {
    formData,
    resetForm,
    setFormDataFromNode,
    updateFormData,
    getFormData
  };
};